import { useRef } from "react";
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileUpload } from "@fortawesome/free-solid-svg-icons";
import { ALLOWED_FILE_MIME_TYPES, ALLOWED_FILE_TYPES } from "../const/data";
import { useState } from "react";

const FileUpload = ({ t, i18n, handleFileChange, multiple = true }) => {
  const fileInput = useRef(null);
  const [fileError, setFileError] = useState("");
  const [fileSizeError, setFileSizeError] = useState("");
  const onButtonClick = () => {
    if (fileInput) {
      fileInput.current.click();
    }
  };

  const handleChange = (event) => {
    const files = event.target.files;
    const maxSizeInBytes = 10 * 1024 * 1024; // 10MB
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      // Check if the file type is in the ALLOWED_FILE_TYPES array
      if (!ALLOWED_FILE_MIME_TYPES.includes(file.type)) {
        setFileError(true);
        return;
      } else if (file && file?.size > maxSizeInBytes) {
        setFileSizeError(true);
        return;
      }
    }
    setFileError(false);
    setFileSizeError(false);
    handleFileChange(files);
  };

  return (
    <div>
      <div>
        <button
          className="btn-lg ns-btn-3rd"
          onClick={onButtonClick}
          name={t("other_adult_living_form.addAnother")}
        >
          <span style={{ marginRight: "10px" }}>
            <FontAwesomeIcon icon={faFileUpload} />
          </span>
          {t("other_adult_living_form.upload_button_name")}
        </button>
      </div>
      <input
        ref={fileInput}
      //   multiple={multiple}
        type="file"
        style={{ display: "none" }}
        onChange={handleChange}
        accept={ALLOWED_FILE_TYPES.join(",")}
      />
      {fileError && (
        <div className="form-group has-error">
          <div className="help-block">
            <i
              aria-label={t("shared.error")}
              className="fa fa-exclamation-circle error-indicator errorAlert"
              aria-hidden="true"
            />
            <span className="ns-visually-hidden">
              {t("errors.hidden_error_msg")}
            </span>
            <span style={{ marginLeft: "10px" }}>
              {t("errors.file_type_error")}
            </span>
          </div>
        </div>
      )}
      {fileSizeError && (
        <div className="form-group has-error">
          <div className="help-block">
            <i
              aria-label={t("shared.error")}
              className="fa fa-exclamation-circle error-indicator errorAlert"
              aria-hidden="true"
            />
            <span className="ns-visually-hidden">
              {t("errors.hidden_error_msg")}
            </span>
            <span style={{ marginLeft: "10px" }}>
              {t("errors.file_size_error")}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default withTranslation("common")(FileUpload);
